export enum PageChangeType {
  First,
  Next,
  Previous,
  Cancel,
  Download,
  Archive,
  Open
}